import React, { useEffect, useState } from "react";

import "./../../../assets/css/Dashboard/PatientListView.scss";

import PatientListView from "./PatientListGridContainer/PatientListView";
import PatientSideFilter from "./PatientSideFilter/PatientSideFilter";
import PatientMapView from "../PatientMapView/PatientMapView";
import { Tabs, Tab } from "@mui/material";
import { BsMap } from "react-icons/bs";
import Campaign from "./CreateCompaign/Campaign";
import useTitanApp from "../../../hooks/useTitanApp";
import CustomLoader from "../../../components/controls/CustomLoader";
import LottieLoader from "../../../components/controls/LottieLoader";

const PatientTab = () => {
  const { appState } = useTitanApp();
  const { isAppLoading, currentPharmacy, darkMode } = appState || {};
  const { patients } = currentPharmacy || {};
  const [totalPatients] = useState(patients?.length || 0);

  const [filteredPatients, setFilteredPatients] = useState(patients || []);

  const [value, setValue] = useState(0);

  const [tabContent, setTabContent] = useState(<LottieLoader />);

  const listviewIcon = (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.13025 10.246C3.79696 10.246 4.33743 10.7865 4.33743 11.4534V13.1767C4.33743 13.8435 3.79696 14.384 3.13025 14.384H1.40718C0.74047 14.384 0.199997 13.8435 0.199997 13.1767V11.4534C0.199997 10.7865 0.74047 10.246 1.40718 10.246H3.13025ZM3.13025 11.2809H1.40718C1.31193 11.2809 1.23472 11.3581 1.23472 11.4534V13.1767C1.23472 13.2719 1.31193 13.3492 1.40718 13.3492H3.13025C3.2255 13.3492 3.30271 13.2719 3.30271 13.1767V11.4534C3.30271 11.3581 3.2255 11.2809 3.13025 11.2809ZM5.54476 11.6244H13.481C13.7667 11.6244 13.9983 11.856 13.9983 12.1418C13.9983 12.4038 13.8037 12.6203 13.5512 12.6545L13.481 12.6592H5.54476C5.25903 12.6592 5.0274 12.4276 5.0274 12.1418C5.0274 11.8798 5.22204 11.6634 5.47456 11.6291L5.54476 11.6244H13.481H5.54476ZM3.13025 5.41584C3.79696 5.41584 4.33743 5.9564 4.33743 6.6232V8.34653C4.33743 9.01333 3.79696 9.55388 3.13025 9.55388H1.40718C0.74047 9.55388 0.199997 9.01333 0.199997 8.34653V6.6232C0.199997 5.9564 0.74047 5.41584 1.40718 5.41584H3.13025ZM3.13025 6.45072H1.40718C1.31193 6.45072 1.23472 6.52794 1.23472 6.6232V8.34653C1.23472 8.44178 1.31193 8.51901 1.40718 8.51901H3.13025C3.2255 8.51901 3.30271 8.44178 3.30271 8.34653V6.6232C3.30271 6.52794 3.2255 6.45072 3.13025 6.45072ZM5.54476 6.79495H13.481C13.7667 6.79495 13.9983 7.02661 13.9983 7.31238C13.9983 7.57434 13.8037 7.79083 13.5512 7.8251L13.481 7.82982H5.54476C5.25903 7.82982 5.0274 7.59816 5.0274 7.31238C5.0274 7.05043 5.22204 6.83393 5.47456 6.79967L5.54476 6.79495H13.481H5.54476ZM3.13025 0.585693C3.79696 0.585693 4.33743 1.12624 4.33743 1.79305V3.51637C4.33743 4.18318 3.79696 4.72373 3.13025 4.72373H1.40718C0.74047 4.72373 0.199997 4.18318 0.199997 3.51637V1.79305C0.199997 1.12624 0.74047 0.585693 1.40718 0.585693H3.13025ZM3.13025 1.62057H1.40718C1.31193 1.62057 1.23472 1.69779 1.23472 1.79305V3.51637C1.23472 3.61163 1.31193 3.68885 1.40718 3.68885H3.13025C3.2255 3.68885 3.30271 3.61163 3.30271 3.51637V1.79305C3.30271 1.69779 3.2255 1.62057 3.13025 1.62057ZM5.54476 1.96553H13.481C13.7667 1.96553 13.9983 2.19719 13.9983 2.48296C13.9983 2.74492 13.8037 2.96142 13.5512 2.99568L13.481 3.0004H5.54476C5.25903 3.0004 5.0274 2.76874 5.0274 2.48296C5.0274 2.22101 5.22204 2.00451 5.47456 1.97025L5.54476 1.96553H13.481H5.54476Z"
        className="icons-color"
      />
    </svg>
  );

  const mapviewIcon = <BsMap className="icons-color" />;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const filterData = () => {
    const filteredPatients =
      patients?.filter((patient) => patient.age > 60) || [];
    setFilteredPatients(filteredPatients);
  };

  useEffect(() => {
    switch (value) {
      case 0:
        setTabContent(
          <PatientListView
            onDarkModeChange={darkMode}
            filteredPatients={filteredPatients}
          />
        );

        break;

      case 1:
        setTabContent(<PatientMapView onDarkModeChange={darkMode} />);

        break;

      case 2:
        setTabContent(<Campaign />);

        break;

      default:
        setTabContent(<LottieLoader />);

        break;
    }
  }, [value]);

  return (
    isAppLoading === false && (
      <div className="patient_tab">
        <PatientSideFilter
          totalPatients={totalPatients}
          filterData={filterData}
        />

        <div className="patientview_wrapper">
          <div className="patientview_tabs">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="Tabs"
              TabIndicatorProps={{
                style: {
                  backgroundColor: "black",
                },
              }}
            >
              <Tab
                icon={listviewIcon}
                iconPosition="start"
                label={<span className={`tabs_text`}>List View</span>}
              />

              <Tab
                icon={mapviewIcon}
                iconPosition="start"
                label={<span className={`tabs_text`}>Map View</span>}
              />

              <Tab
                icon={mapviewIcon}
                iconPosition="start"
                label={<span className={`tabs_text`}>Campaign</span>}
              />
            </Tabs>
          </div>

          <div className="patientview_container-content-area">{tabContent}</div>
        </div>
      </div>
    )
  );
};

export default PatientTab;
